// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__wMT7y","primary":"style_primary__EEHU_","block":"style_block__rs7N0"};